import { inject } from '@angular/core'
import type { CanActivateFn } from '@angular/router'
import { Router } from '@angular/router'
import { AdminAuthService } from './admin-auth.service'

export const adminRoleGuard: CanActivateFn = () => {
  const auth = inject(AdminAuthService)
  const router = inject(Router)

  const principal = auth.principal()
  if (!principal) {
    return router.parseUrl('/login')
  }

  if (principal.roles.includes('admin')) {
    return true
  }

  return router.parseUrl('/dashboard')
}
